<template>
  <div>
    <el-dialog :visible="true" width="100%" :show-close="false" class="reInfo">
      <div class="borderrd">
        <AppointText :appoint="schedule"></AppointText>
      </div>
      <div class="text borderrd">
        <ReminderText></ReminderText>
      </div>
      <span slot="footer">
        <el-button @click="cancel" round>取 消</el-button>
        <el-button type="primary" @click="confirmSchedule" round>确 定</el-button>
      </span>
    </el-dialog>  
  </div>
</template>

<script>
import AppointText from '@/components/appointText'
import ReminderText from '@/components/reminderText.vue';
export default { 
  components: {
    AppointText,
    ReminderText,
  },    
  props: {
    schedule: Object,
  },   
  data() {
    return {
    };
  },
  mounted() {   
  },  
  methods: {
    cancel(){
      this.$emit('cancel-confirmSchedule');
    },
    confirmSchedule(){
      this.$emit('confirm-schedule');
    }
  }
};
</script>
<style scoped>
>>> .el-dialog {
  position: absolute;
  bottom: 0;
  margin: 0;
}
.borderrd {
  border-radius: 10px;
  border: 1px solid #ccc;
  padding: 10px;
  margin-bottom: 10px;
}
</style>
